import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { catchError } from 'rxjs';

@Component({
    selector: 'app-predem-info-page',
    templateUrl: './predem-info-page.component.html',
    styleUrls: ['./predem-info-page.component.scss'],
    standalone: false
})
export class PredemInfoPageComponent implements OnInit {
  infoPanel: SafeHtml;
  htmlString: string;
 
  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getInfoPanelContent();
  }
  private getInfoPanelContent() {
    let fileName = "preDemInfo";
    let origFileName = fileName
    fileName += '.' + this.locale.language.toLowerCase() + '.html';
    let path = 'assets/info/' + fileName;

    this.http.get(path, { responseType: 'text' }).pipe(
      catchError(() => {
        if (this.locale.language.toLowerCase() == "en-gb") {
          //Ha nincs brit angol fordítás, akkor vesszük az amerikait
          path = 'assets/info/' + origFileName + ".en-us.html";
        }
        return this.http.get(path, { responseType: 'text' });
      })
    ).subscribe(
      data => {
        this.htmlString = data;
        this.infoPanel = this.sanitizer.bypassSecurityTrustHtml(this.htmlString);
      }
    );
  }

}
